module.exports = __webpack_public_path__ + "static/media/3ds.5c776655.svg";